import Vue from 'vue'

import { projectName } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { services } from '@/utils'

import render from './render'

const Cache = new Macro({
  ttl: 5 * 1000,
  ttlInterval: 1000
})

const cachedGet = Cache.wrapWithCache(async (key, service, id) => {
  return await Vue.$GRequest?.get(service, id)
})

export default {
  name: 'Billings',

  props: {
    value: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      loading: false,

      items: []
    }
  },

  computed: {
    ids() {
      return this.value?.meta?.billings?.ids || []
    },
    id() {
      return this.value?.meta?.billing?.id
    }
  },

  mounted() {
    this.get()
  },

  methods: {
    async get() {
      try {
        this.loading = true
        const items = Array.isArray(this.ids) && this.ids.length ? this.ids : [ this.id ]
        if (Array.isArray(items) && items.length) {
          this.items = await Promise.all(items.map(async id => {
            const key = [ projectName, services.billings, 'get', id ].filter(Boolean).join(':')
            const response = await cachedGet(key, services.billings, id)
            if (response?.data) {
              this.loading = false

              return response.data
            }
          }))
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    }
  },

  render
}
